import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '@dorixona/api'

/** 4xx answers are final — only network and 5xx failures are worth a retry. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false
  if (isApiError(error) && error.status < 500) return false
  return true
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetry, refetchOnWindowFocus: false, staleTime: 30_000 },
      mutations: { retry: false },
    },
  })
}
